import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-terms-of-use-nigeria',
    templateUrl: './terms-of-use-nigeria.component.html',
    styleUrls: ['./terms-of-use-nigeria.component.css'],
})
export class TermsOfUseNigeriaComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<TermsOfUseNigeriaComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
